import { graphClient } from "../graph-client";
import {
  CONVERT_AGENCY_POINTS_TO_COINS,
  GET_AGENCY_POINTS_CONVERT_QUOTE,
} from "./gql";
import { Convert, GetQuote } from "./types";

class AgencyPointsConvertService {
  async getQuote() {
    const request = await graphClient.request<GetQuote.Output>(
      GET_AGENCY_POINTS_CONVERT_QUOTE
    );
    return request?.getAgencyPointsConvertQuote;
  }

  async convert(params: Convert.Input) {
    const request = await graphClient.request<Convert.Output>(
      CONVERT_AGENCY_POINTS_TO_COINS,
      { ...params }
    );
    return request?.convertAgencyPointsToCoins;
  }
}

export const agencyPointsConvertService = new AgencyPointsConvertService();
